import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns and unassigns Driver Groups to a Specific Driver
 * @param id The ID of the Driver being used for assignment
 * @param assignmentDriverGroupIds The IDs of the Driver Groups being assigned
 * @param unassignmentDriverGroupIds The IDs of the Driver Groups being unassigned
 * @returns Data object containing array of unassigned Driver Group's IDs
 */
export function postDriversDriverGroupsCombinedAssignment(
  this: unknown,
  id: number,
  assignmentDriverGroupIds: number[],
  unassignmentDriverGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .driversDriverGroupsCombinedAssignmentUrl(id),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentDriverGroupIds,
            unassignmentDriverGroupIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.number()),
          unassigned: z.array(z.number()),
        }),
      })
    )
  );
}
